class StoreZoneShapeType {
  constructor (
    id = undefined,
    name
  ) {
    this.id = id
    this.name = name
  }

  toNormalizedRESTModel () {
    return ({
      // id is read-only
      name: this.name
    })
  }

  static FromNormalizedRESTModel ({
    id,
    name
  }) {
    return new StoreZoneShapeType(
      id,
      name
    )
  }

  toJSON () {
    return {
      id: this.id,
      name: this.name
    }
  }

  static FromJSON ({
    id,
    name
  }) {
    return new StoreZoneShapeType(
      id,
      name
    )
  }
}

StoreZoneShapeType.SHAPE_TYPE_IDS = {
  CIRCLE: 0,
  POLYGON: 1,
  CORRIDOR: 2
}

/**
 * Map form shapeTypeId to geometry kind for map editing.
 * Handles MUI Select string values ("1" vs 1) and API ids (including UUIDs) via loaded shape types.
 * @param {number|string|null|undefined} shapeTypeId
 * @param {Array<{ id: *, name: string }>} [shapeTypesFromStore]
 * @returns {'circle'|'polygon'|'corridor'|null}
 */
StoreZoneShapeType.resolveGeometryKind = (shapeTypeId, shapeTypesFromStore = []) => {
  if (shapeTypeId === '' || shapeTypeId == null) return null
  const n = Number(shapeTypeId)
  if (!Number.isNaN(n)) {
    if (n === StoreZoneShapeType.SHAPE_TYPE_IDS.CIRCLE) return 'circle'
    if (n === StoreZoneShapeType.SHAPE_TYPE_IDS.POLYGON) return 'polygon'
    if (n === StoreZoneShapeType.SHAPE_TYPE_IDS.CORRIDOR) return 'corridor'
  }
  const meta = shapeTypesFromStore.find(st => String(st.id) === String(shapeTypeId))
  if (!meta?.name) return null
  const name = String(meta.name).toLowerCase()
  if (name === 'circle') return 'circle'
  if (name === 'polygon') return 'polygon'
  if (name === 'corridor') return 'corridor'
  return null
}

export default StoreZoneShapeType
